import {
  GOVERNANCE_LICENSE_IDS,
  type AccessLevel,
  type TeamEffectiveRightsByProductType,
} from '@eye-able/types';

export type GovernanceArea = keyof typeof GOVERNANCE_LICENSE_IDS;

type GovernanceAccessUser = {
  isAdmin?: boolean;
  isSalesAdmin?: boolean;
};

export function getGovernanceAccessLevel({
  area,
  demoMode = false,
  effectiveRights,
  user,
}: {
  area: GovernanceArea;
  demoMode?: boolean;
  effectiveRights: TeamEffectiveRightsByProductType | null | undefined;
  user: GovernanceAccessUser | null | undefined;
}): AccessLevel | null {
  if (demoMode || user?.isAdmin || user?.isSalesAdmin) {
    return 'editor';
  }

  if (!effectiveRights) return null;

  return (
    effectiveRights.governance.find(
      ({ licenseId }) => licenseId === GOVERNANCE_LICENSE_IDS[area],
    )?.accessLevel ?? null
  );
}
